import React, { FC } from 'react'
import styled from 'styled-components'
import { MembershipProgramHatoHeart } from 'types/membershipProgram'
import useMembershipProgram from 'hooks/hato-heart/useMembershipProgram'

interface MembershipTierImageProps {
  membershipTier: string
  membershipProgramHH: MembershipProgramHatoHeart
}

const MembershipTierImage: FC<MembershipTierImageProps> = ({ membershipTier, membershipProgramHH }) => {
  const { tierImage, coverImage } = useMembershipProgram({ memberShipprogram: membershipProgramHH, membershipTier })
  const currentTierImage = tierImage ?? coverImage
  return currentTierImage ? <MemberCoverNormal alt="membership-card" src={currentTierImage} /> : null
}
export default MembershipTierImage

const MemberCoverNormal = styled.img`
  width: 100%;
  border-radius: ${({ theme }) => theme.radius.xl};
  box-shadow: ${({ theme }) => theme.shadow.regular};
`
